import { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { Download, Loader } from 'lucide-react'
import { Button } from '@/components/shadcn/button'
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from '@/components/shadcn/tooltip'
import { axiosInstance } from '@/api/axios-instance'
import { notify } from '@/lib/notify'

export function BulkDownloadInviteCodesButton() {
  const { t } = useTranslation('employees')
  const [isDownloading, setIsDownloading] = useState(false)

  const handleDownload = async () => {
    setIsDownloading(true)
    try {
      const response = await axiosInstance.get('/api/companymanagementuser/onboardingfiles', {
        responseType: 'blob',
      })
      const url = window.URL.createObjectURL(response.data)
      const a = document.createElement('a')
      a.href = url
      a.download = 'Onboarding_Documents.zip'
      document.body.appendChild(a)
      a.click()
      a.remove()
      window.URL.revokeObjectURL(url)
    } catch {
      notify.error(t('toasts.inviteDownloadError'))
    } finally {
      setIsDownloading(false)
    }
  }

  return (
    <TooltipProvider>
      <Tooltip>
        <TooltipTrigger asChild>
          <Button
            variant="outline"
            size="icon"
            className="h-9 w-9"
            onClick={handleDownload}
            disabled={isDownloading}
          >
            {isDownloading ? <Loader className="h-4 w-4 animate-spin" /> : <Download className="h-4 w-4" />}
          </Button>
        </TooltipTrigger>
        <TooltipContent>{t('actions.bulkInviteTooltip')}</TooltipContent>
      </Tooltip>
    </TooltipProvider>
  )
}
